import { deref } from "kanopi-components/utils/primitives";

export const getQuestionSetAnswers = (
  questionSet: TQuestionSet,
  data: TRiskData | TClaimData
) => {
  return (questionSet?.questions || []).reduce(
    (answers, question) => ({
      ...answers,
      [question.id]: deref(data, question.storagePath, question.default),
    }),
    {}
  );
};
